<template>
  <div class="block">
    <el-slider
      v-model="value"
    >
    </el-slider>

    <div class="manual">
        <span>输入数量</span>
        <el-input-number v-model="value" @change="handleChange" :min="1" :max="100" label="输入数量"></el-input-number>
    </div>

    <div class="sum">购买{{ value }}经验</div>
  </div>    
</template>

<script>
  export default {
    data() {
      return {
        value: 0
      }
    },
    methods : {
      handleChange(value) {
        console.log(value);
      },        
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/buy.vue